// extracted by mini-css-extract-plugin
export var notificationHost = "_l7-0";